/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('TicketCtrl', function($scope, identity, tickets, Ticket) {
    $scope.me            = identity;
    $scope.tickets       = tickets;
    $scope.unread        = Ticket.getUnread();
    $scope.status_filter = 'maj';

    $scope.isFiltered = function(ticket) {
        switch ($scope.status_filter) {
            case 'maj':    return (0 < ticket.view) || (ticket.view === null);
            case 'open':   return null === ticket.closed_at;
            case 'closed': return null !== ticket.closed_at;
        }
    };

    return $scope.setFilter = status => $scope.status_filter = status;
});
